import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';

export default function TheComp() {
    const { t } = useLang('theProduct.HighlightsA');
    return (
        <>
            <EfImg
                pc="https://websiteoss.ecoflow.com/upload/image/1724560968758/high_light_1.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1724560968758/high_light_1.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1724569075068/high_light_1_h5.jpg"
            />
            <div className="card-box card-box1">
                <div className="card-title">{t('item1_title')}</div>
                <div className="card-desc">{t('item1_desc')}</div>
            </div>
        </>
    );
}
